import React, { useState } from "react";
import { useSelector } from "react-redux";
import ChartLine from "../components/ChartLine";
import { AiOutlineCaretDown } from "react-icons/ai";
import Loader from "../components/Loader";

const Temperature = () => {
  const { temp_list, temp_loading } = useSelector((state) => state.temp);
  const { date, current_tab } = useSelector((state) => state.other);
  const [id, setId] = useState("");

  const data1 = [];
  for (let j = 0; j < temp_list.length; j++) {
    const data = [];
    for (let i = 0; i < temp_list[j].data.length; i++) {
      const element = {
        name: temp_list[j]?.data[i]?.datetime,
        median: temp_list[j].median,
        temperature: temp_list[j]?.data[i]?.temperature,
      };
      data.push(element);
    }
    data1.push({
      name: temp_list[j].uuid,
      data: data,
      max: temp_list[j].max,
    });
  }

  return (
    <div className="main-home-container">
      <div className="date-picker-header">
        <div className="title">Temperature</div>
        <div style={{ maxWidth: "20%", width: "100%" }} />
        <div className="title" style={{ color: "darkblue" }}>
          {date.start + "  " + "-" + "  " + date.end}
        </div>
      </div>

      {temp_loading ? (
        <Loader />
      ) : (
        <div className="">
          {data1?.map((v, i) => (
            <div key={i} className={`${i + 1 == id && "lightblue"} bg mb10`}>
              <div
                className="container"
                onClick={() => setId(i + 1 == id ? "" : i + 1)}
              >
                <div className="temp-heading"> {v?.name}</div>
                <AiOutlineCaretDown size={20} />
              </div>

              {i + 1 == id &&
                (v.data.length != 0 ? (
                  <div className="mb10">
                    <ChartLine
                      data={v.data}
                      dataKey="temperature"
                      max={Number(v.max) + 20}
                      // min={200}
                    />
                    <div className="graph-value-wrap">
                      <div
                        className="title-value "
                        style={{ color: "darkgreen" }}
                      >
                        Mean :<span>{temp_list[i]?.mean}°C</span>
                      </div>
                      <div
                        className="title-value"
                        style={{ color: "darkblue" }}
                      >
                        Median :<span>{temp_list[i]?.median}°C</span>
                      </div>
                      <div className="title-value" style={{ color: "purple" }}>
                        Mode :<span>{temp_list[i]?.mode}°C</span>
                      </div>
                      <div className="title-value" style={{ color: "magenta" }}>
                        Standard Deviation :<span>{temp_list[i]?.sd}°C</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="no-data ">No data</div>
                ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Temperature;
